import { render, staticRenderFns } from "./CourseTable.vue?vue&type=template&id=af4eb6b8&scoped=true"
import script from "./CourseTable.vue?vue&type=script&lang=js"
export * from "./CourseTable.vue?vue&type=script&lang=js"
import style0 from "./CourseTable.vue?vue&type=style&index=0&id=af4eb6b8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4eb6b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af4eb6b8')) {
      api.createRecord('af4eb6b8', component.options)
    } else {
      api.reload('af4eb6b8', component.options)
    }
    module.hot.accept("./CourseTable.vue?vue&type=template&id=af4eb6b8&scoped=true", function () {
      api.rerender('af4eb6b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/course/components/CourseTable.vue"
export default component.exports